import EthereumSigner from "./ethereumSigner";

export default class PolygonSigner extends EthereumSigner {}
